const multiEditReducer = (state = false, action) => {
    switch(action.type) {
        case 'SWITCH_MULTI_EDIT':
            return !state;
        default:
            return state;
    }
}

export default multiEditReducer;